<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               top="10px"
               @open="open()"
               width="1100px">
      <div>
        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <!-- <el-form-item label="消息状态">
            <el-select v-model="query.message_statuses"
                       @change="getLists()"
                       clearable
                       placeholder="请选择类型"
                       style="width: 100%;">
              <el-option v-for="(item, index) in filter.status"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="沟通人">
            <el-input v-model="query.sender_user_keyword"
                      placeholder="请输入沟通人姓名/手机号"
                      @input="getLists(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker class="datetime"
                            v-model="createDatetime"
                            :clearable="true"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="timestamp"
                            @change="getLists(true)">

            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="replayContent">

        <div class="replayBox"
             ref="chatListRef"
             @scroll="handleChatScroll">
          <div v-for="(item,index) in result"
               :key="index">
            <div class="time">
              {{ formatTime(item.create_time) }}
            </div>
            <div class="systmMessage"
                 v-if="item.system_message_status==1">
              {{item.message}}
            </div>
            <div class="chatItem"
                 :class="{ positionSender: item.system_message_status ==2||item.system_message_status ==3||item.system_message_status ==4}">
              <template v-if="item.system_message_status==0">

                <div class=""
                     v-if="item.sender_user_obj">
                  <img :src="item.sender_user_obj?item.sender_user_obj.avatar :'https://upload.kaoyanbox.net/7c9bbe67d4f3c51b6a5718ab5bcfe2c2.jpeg'"
                       class="chatLogo" />
                </div>
                <div class=""
                     v-else>
                  <img src="https://upload.kaoyanbox.net/7c9bbe67d4f3c51b6a5718ab5bcfe2c2.jpeg"
                       class="chatLogo" />
                </div>
                <div class="chatContent">
                  <div class="chatTop"
                       v-if="item.system_message_status ==0"><span class="nickeName">{{item.sender_user_obj?item.sender_user_obj.nickname :''}}</span> <span
                          class="identity">{{item.sender_user_type==1 ? '学生' :'学长'}}</span></div>
                  <div v-if="item.system_message_status ==0"
                       style="display:flex; align-items: center;">
                    <!-- 适配推荐笔记 -->
                    <div class="recommedNote"
                         v-if="item.message_note_obj"
                         @click="handleGoNote(item)">
                      <img :src="item.message_note_obj.cover_img_url"
                           class="coverImg" />
                      <p class="noteTitle">{{item.message_note_obj.title}}</p>
                      <div class="noteBottom">
                        <p class="bottomLeft"><el-avatar :src="item.message_note_obj.author_user_avatar"
                                     style="width:18px;height:18px"></el-avatar>
                          <text style="margin-left: 8rpx;">{{ item.message_note_obj.author_user_nickname }}</text>
                        </p>
                        <p class="bottomRight">
                          <img src="https://upload.kaoyanbox.net/93dc4f5359236b53545d9380d0d8f27b.png" />

                          <span style="margin-top: -3rpx;">{{item.message_note_obj.total_like_count}}</span>
                        </p>
                      </div>
                    </div>
                    <!-- 适配推荐1v1 -->
                    <div class="v-msg"
                         v-else-if="item.content_type==5">
                      <div>
                        <div>
                          <img src="https://upload.kaoyanbox.net/60e10898a41b2da6683e47f6dc260c2f.png"
                               mode="widthFix"
                               style="width: 150px;"
                               class="replayImg" />
                        </div>
                      </div>
                    </div>
                    <!-- 适配图片开始 -->
                    <div class=""
                         v-else-if="item.message_img_url !=''">
                      <img :src="item.message_img_url"
                           mode="widthFix"
                           style="max-width: 350rpx;"
                           class="replayImg"
                           @click="preview(item.message_img_url)" />
                    </div>

                    <div v-else> <span class="chatMessage">{{item.message}}</span> </div>
                    <span style="color: #409EFF; marginRight:10px;marginTop:10px"
                          @click="handeWihdraw(item)"
                          v-if="item.message_status==1">隐藏</span><span style="color: #409EFF; marginRight:10px;marginTop:10px"
                          @click="cancleWihdraw(item)"
                          v-if="item.message_status==2">取消隐藏</span> <span style="color: #409EFF;marginTop:10px"
                          @click="banned(item,1)"
                          v-if="item.sender_chat_disable_status==0">禁言</span> <span @click="banned(item,2)"
                          style="color: #409EFF;marginTop:10px"
                          v-if="item.sender_chat_disable_status==1">取消禁言</span>
                  </div>
                </div>
              </template>
              <template v-else-if="item.system_message_status==2||item.system_message_status==3||item.system_message_status==4">
                <div class=""
                     v-if="item.sender_user_obj">
                  <img :src="item.sender_user_obj?item.sender_user_obj.avatar :'https://upload.kaoyanbox.net/7c9bbe67d4f3c51b6a5718ab5bcfe2c2.jpeg'"
                       class="chatLogo" />
                </div>
                <div class=""
                     v-else>
                  <img src="https://upload.kaoyanbox.net/7c9bbe67d4f3c51b6a5718ab5bcfe2c2.jpeg"
                       class="chatLogo" />
                </div>
                <div class="chatContent">
                  <div class="chatTop"><span class="nickeName">{{item.sender_user_obj?item.sender_user_obj.nickname :''}}</span> <span class="xuidentity"
                          v-if="item.sender_user_type==1&&item.system_message_status !=2">虚拟学生</span><span class="xuidentity"
                          v-if="item.sender_user_type==2&&item.system_message_status !=2">虚拟学长</span></div>
                  <div>
                    <!-- 适配推荐笔记 -->
                    <div class="recommedNote"
                         v-if="item.message_note_obj"
                         @click="handleGoNote(item)">
                      <img :src="item.message_note_obj.cover_img_url"
                           class="coverImg" />
                      <p class="noteTitle">{{item.message_note_obj.title}}</p>
                      <div class="noteBottom">
                        <p class="bottomLeft"><el-avatar :src="item.message_note_obj.author_user_avatar"
                                     style="width:18px;height:18px"></el-avatar>
                          <text style="margin-left: 8rpx;">{{ item.message_note_obj.author_user_nickname }}</text>
                        </p>
                        <p class="bottomRight">
                          <img src="https://upload.kaoyanbox.net/93dc4f5359236b53545d9380d0d8f27b.png" />

                          <span style="margin-top: -3rpx;">{{item.message_note_obj.total_like_count}}</span>
                        </p>
                      </div>
                    </div>
                    <!-- 适配企业微信链接 -->
                    <div class=""
                         v-else-if="item.message_enterprise_wechat_url !=''">
                      <div class="wechat">
                        <div class="wechatContent">
                          <div class="loginLeft">
                            <img src="https://upload.kaoyanbox.net/8641395462c0d07f7ec83060545a37ec.png"
                                 @load="loadTower()" />

                            加入群聊
                          </div>
                          <div class="loginRight">
                            <img src="https://upload.kaoyanbox.net/13d8b7746358eea0628aabe7d6463180.png"
                                 @load="loadTower" />
                          </div>
                        </div>
                        <div class="
                                 cell"
                             style="opacity: 0;">
                          <cells :url="item.message_enterprise_wechat_url"
                                 iconBorderRadius="16"
                                 contactText=" 1"
                                 style="font-size: 16rpx;"
                                 paddingStyle="30">
                          </cells>
                        </div>
                      </div>
                    </div>
                    <div class="v-msg"
                         v-else-if="item.content_type==5">
                      <div>
                        <img src="https://upload.kaoyanbox.net/60e10898a41b2da6683e47f6dc260c2f.png"
                             mode="widthFix"
                             style="width: 150px;"
                             class="replayImg" />
                      </div>
                    </div>
                    <!-- 适配图片开始 -->
                    <div class=""
                         v-else-if="item.message_img_url !=''">

                      <img :src="item.message_img_url"
                           mode="widthFix"
                           style="width: 150px;"
                           class="replayImg"
                           @click="preview(item.message_img_url)" />
                    </div>

                    <div class="chatMessage"
                         v-else>{{item.message}}</div>
                  </div>
                </div>

              </template>
            </div>
          </div>
        </div>
        <!-- 发送消息 -->
        <div class="senderBottom">
          <el-input type="textarea"
                    rows="7"
                    placeholder="请在这里输入聊天内容"
                    border="none"
                    v-model="message"></el-input>
          <div class="xian"></div>
          <div class="senderText">
            <div class="Left">
              <p class="Left">
                <img src="https://upload.kaoyanbox.net/bda81e91dea7645a27405517513ef29b.png"
                     style="marginRight:5px" />
                <input @change="upload"
                       type="file"
                       name="photoImg"
                       id="getFile"
                       style="display:none;"
                       class="upload-input" />
                <label for="getFile"
                       class="fileStyle">图片</label>
              </p>
              <p @click="recommend1v1">
                <i class="el-icon-collection"
                   style="font-size: 20px;"></i> 推荐报名1v1
              </p>
            </div>

            <div style="display:flex">
              <span style="marginTop:5px">发送人：</span>
              <el-select v-model="value"
                         placeholder="请选择"
                         style="width:120px">
                <el-option v-for="item in senderName"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                  <span style="float: left">{{ item.label }}</span>
                </el-option>
              </el-select>
              <p class="senderBtn"
                 @click="handleSender(false)">发送</p>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>

  </div>
</template>

<script>
import {
  messageList,
  messageHide,
  hideCancel,
  chatUserExtend,
  sendMessages,
} from '@/api/senior'
import { uploadImg } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      message: '',
      createDatetime: '',
      result: [],
      dialogVisible: this.visible,
      query: {
        pageIndex: 1,
        isPaging: 1,
        pageSize: 10,
      },
      pageTotal: 10,
      isLoadingMore: false,
      filter: {
        status: [
          { label: '正常', value: '1' },
          { label: '撤回', value: '2' },
        ],
        type: [
          { label: '沟通列表', value: '0' },
          { label: '消息列表', value: '1' },
        ],
      },
      senderName: [
        {
          value: 1,
          label: '系统',
        },
        {
          value: 2,
          label: '客服',
        },
        {
          value: 3,
          label: '系统代学生',
        },
        {
          value: 4,
          label: '系统代学长',
        },
      ],
      value: 1,
      message_img_url: '',
      productid: '',
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    upload(e) {
      const file = e.target.files[0]

      if (file) {
        let formData = new FormData()
        formData.append('file', file)
        uploadImg(formData).then((res) => {
          this.message_img_url = res.url

          if (res) {
            this.handleSender(true)
          }
        })
        // bulkCreateLiveRoomByFile(formData).then((res) => {
        //   console.log('res', res)
        //   if (res == null) {
        //     this.$message.success(`导入成功`)
        //     this.fetchCourseList()
        //   }
        // })
      }
    },
    recommend1v1() {
      this.productid = '8581'
      this.handleSender()
    },
    handleSender(photo) {
      let data = {
        senior_chat_id: this.query.senior_chat_id,
        content_type: 1,
        message: this.message,
        system_message_status: this.value,
      }
      if (photo) {
        data.content_type = 2
        data.message_img_url = this.message_img_url
      }
      if (this.productid) {
        data.content_type = 5
        data.message_course_id = this.productid
      }
      sendMessages(data).then((res) => {
        this.message = ''
        this.productid = ''
        this.$message.success('发送成功')
        this.result = []
        this.query.pageIndex = 1
        this.pageTotal = 10
        this.getLists()
      })
    },
    // 封装：滚动到聊天列表最底部（通用方法）
    scrollToBottom() {
      this.$nextTick(() => {
        setTimeout(() => {
          const chatListEl = this.$refs.chatListRef
          if (chatListEl) {
            // scrollTop 设置为容器的总高度，即可滚动到底部
            chatListEl.scrollTop = chatListEl.scrollHeight
          }
        }, 300)
      })
    },
    // 监听聊天列表滚动事件
    handleChatScroll() {
      const chatListEl = this.$refs.chatListRef
      // 滚动条距离顶部的距离 <= 10 时触发加载（阈值10避免精准到0触发不灵敏）
      if (chatListEl.scrollTop <= 10 && !this.isLoadingMore) {
        this.loadChatHistory()
      }
    },
    // 加载历史聊天消息（核心请求方法）
    async loadChatHistory() {
      try {
        // this.isLoadingMore = true // 标记加载中

        // 1. 记录加载前的滚动容器高度（用于后续调整滚动位置）
        // const chatListEl = this.$refs.chatListRef
        // const oldScrollHeight = chatListEl.scrollHeight
        // const oldScrollTop = chatListEl.scrollTop // 新增：记录加载前的scrollTop
        if (this.result.length < this.pageTotal) {
          this.query.pageIndex++
          this.getLists()

          // chatListEl.scrollTop = newScrollHeight - oldScrollHeight + oldScrollTop
        }

        // 2. 模拟请求接口（替换成你的真实接口）
        // const res = await this.$axios.get('/api/chat/history', {
        //   params: {
        //     pageNum: this.pageNum,
        //     pageSize: this.pageSize,
        //     chatId: 'xxx' // 你的聊天会话ID
        //   }
        // })

        // const newHistoryList = res.data.list // 新加载的历史消息（数组）
        // if (newHistoryList.length > 0) {
        //   // 3. 历史消息添加到列表头部（关键：网上滑加载的是更早的消息）
        //   this.chatList = [...newHistoryList, ...this.chatList]
        //   this.pageNum += 1 // 页码+1
        // } else {
        //   this.hasMore = false // 没有更多消息了
        // }

        // 4. 调整滚动位置：加载新消息后，保持用户视觉位置不变
        // this.$nextTick(() => {
        //   const newScrollHeight = chatListEl.scrollHeight
        //   chatListEl.scrollTop = newScrollHeight - oldScrollHeight
        // })
      } catch (err) {
        console.error('加载历史消息失败：', err)
        this.$message.error('加载失败，请重试')
      } finally {
        // this.isLoadingMore = false // 取消加载中标记
      }
    },
    handleClose() {
      this.result = []
      this.pageTotal = 10
      this.query.pageIndex = 1
      this.dataForm = {}
      this.$emit('close')
    },
    open() {
      this.query.pageIndex = 1

      this.getLists()
    },
    //禁言
    banned(row, type) {
      let data = {}
      if (type == 1) {
        data = {
          uid: row.sender_chat_user_uid,
          chat_disable_status: 1,
        }
        this.$confirm('确定要禁言吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then((res) => {
          chatUserExtend(data).then((res) => {
            this.$message.success(`操作成功`)
            this.result.map((item) => {
              if (item.id == row.id) {
                item.sender_chat_disable_status = 1
              }
            })
          })
        })
      } else {
        data = {
          uid: row.sender_user_obj.id,
          chat_disable_status: 0,
        }
        this.$confirm('确定要取消禁言吗？', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then((res) => {
          chatUserExtend(data).then((res) => {
            this.$message.success(`操作成功`)
            this.result.map((item) => {
              if (item.id == row.id) {
                item.sender_chat_disable_status = 0
              }
            })
          })
        })
      }
    },
    //撤回
    handeWihdraw(row) {
      this.$confirm('确定要隐藏吗？', '提示', {
        confirmButtonText: '确定隐藏',
        type: 'warning',
      }).then((res) => {
        messageHide({ senior_chat_message_id: row.id }).then((res) => {
          // this.getLists()
          // this.$emit('getlist')
          this.$message.success(`操作成功`)

          this.result.map((item) => {
            if (item.id == row.id) {
              item.message_status = 2
            }
          })
        })
      })
    },
    cancleWihdraw(row) {
      this.$confirm('确定要取消吗？', '提示', {
        confirmButtonText: '确定取消隐藏',
        type: 'warning',
      }).then((res) => {
        hideCancel({ senior_chat_message_id: row.id }).then((res) => {
          // this.getLists()
          // this.$emit('getlist')
          this.$message.success(`操作成功`)
          this.result.map((item) => {
            if (item.id == row.id) {
              item.message_status = 1
            }
          })
        })
      })
    },
    // 拿到相关消息
    getLists(reset) {
      if (reset) {
        this.query.pageIndex = 1
        this.result = []
      }
      if (this.title == '聊天详情') {
        this.query.senior_chat_id = this.content.id
      } else {
        this.query.senior_chat_id = this.content.senior_chat_id
      }
      if (this.createDatetime && this.createDatetime.length > 0) {
        this.query.start_create_time = this.createDatetime[0]
        this.query.end_create_time = this.createDatetime[1]
      } else {
        this.query.start_create_time = ''
        this.query.end_create_time = ''
      }
      this.isLoadingMore = true
      messageList(this.query).then((res) => {
        this.pageTotal = res.count
        if (this.result.length == 0) {
          this.result = res.list.reverse()
          this.scrollToBottom()
        } else {
          res.list.map((item) => {
            this.result.unshift(item)
          })

          const chatListEl = this.$refs.chatListRef
          const oldScrollHeight = chatListEl.scrollHeight
          const oldScrollTop = chatListEl.scrollTop // 新增：记录加载前的scrollTop

          this.$nextTick(() => {
            const newScrollHeight = chatListEl.scrollHeight
            // 关键修改4：调整滚动位置公式，避免固定在顶部
            chatListEl.scrollTop =
              newScrollHeight - oldScrollHeight + oldScrollTop
          })
        }
        this.isLoadingMore = false
      })
    },
    handleGoNote() {},
    preview() {},
    widthDraw(row) {},
    undercarriage(row) {},
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.getLists()
    },
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getLists()
    },
    formatTime(timestamp) {
      const now = new Date()
      const date = new Date(timestamp)
      const todayStart = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      ).getTime()
      const oneDay = 1000 * 60 * 60 * 24
      const oneWeek = oneDay * 7

      // 如果是今天的消息，显示小时和分钟
      if (timestamp >= todayStart) {
        return this.formatHourMinute(date)
      }
      // 如果是昨天的消息，显示“昨天 时分”
      else if (timestamp >= todayStart - oneDay && timestamp < todayStart) {
        return `昨天 ${this.formatHourMinute(date)}`
      }
      // 如果是一周内的消息，显示星期几
      else if (timestamp >= todayStart - oneWeek) {
        return this.getWeekDay(date)
      }
      // 超过一周的消息，显示年月日和时分
      else {
        return this.formatFullDate(date)
      }
    },

    formatHourMinute(date) {
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    getWeekDay(date) {
      const weekDays = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ]
      return weekDays[date.getDay()]
    },
    formatFullDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
  },
}
</script>

<style lang="less" scoped>
.thumbnail {
  width: 38px;
  height: 38px;
}
::v-deep .el-dialog__header {
  background: #ecf2fe;
}
::v-deep .el-textarea__inner {
  border: none !important;
}
.dialog-wrap {
  .replayContent {
    width: 990px;
    min-height: 600px;
    background: #e8e8e8;
    border-radius: 0px 0px 4px 4px;
    padding-bottom: 4px;
    .replayBox {
      padding: 24px 24px;
      width: 1004px;
      height: 600px;
      overflow-y: scroll;
      background: #e8e8e8;
      border-radius: 0px 0px 4px 4px;
      .time {
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        color: #909399;
      }
      .systmMessage {
        margin-top: 10px;
        text-align: center;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
      .chatItem {
        display: flex;
        margin-bottom: 30px;
        .chatLogo {
          margin-left: 10px;
          background: #ffffff;
          border-radius: 50%;
          width: 53px;
          height: 53px;
        }
        .chatContent {
          max-width: 415px;
          margin-left: 10px;
          .chatTop {
            margin-bottom: 10px;
            .nickeName {
              font-weight: 700;
              font-size: 16px;
              color: #333333;
            }
            .identity {
              display: inline-block;
              font-weight: 700;
              font-size: 12px;
              color: #ffffff;
              text-align: center;
              width: 36px;
              height: 16px;
              line-height: 16px;
              background: #999999;
              border-radius: 6px 6px 6px 6px;
            }
            .xuidentity {
              display: inline-block;
              font-weight: 700;
              font-size: 12px;
              color: #ffffff;
              text-align: center;
              width: 60px;
              height: 23px;
              line-height: 23px;
              background: #999999;
              border-radius: 10px;
            }
            .time {
              color: #909399;
              margin-left: 2px;
              font-weight: 400;
              font-size: 14px;
              color: #909399;
              font-weight: 400;
            }
            .system {
            }
          }
          .recommedNote {
            margin-right: 10px;
            width: 160px;
            height: 240px;
            background: #fff;
            border-radius: 4px 4px 0px 0px;

            .coverImg {
              width: 100%;
              height: 182px;
            }

            .noteTitle {
              margin: 8px auto;
              width: 150px;
              font-weight: 500;
              font-size: 12px;
              color: rgba(0, 0, 0, 0.9);
              white-space: nowrap;
              /* 防止文本换行 */
              overflow: hidden;
              /* 隐藏溢出的文本 */
              text-overflow: ellipsis;
              /* 显示省略号 */
            }

            .noteBottom {
              margin: 0px auto;
              width: 150px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: 400;
              font-size: 10px;
              color: rgba(0, 0, 0, 0.6);

              .bottomLeft {
                display: flex;
                // align-items: center;
              }

              .bottomRight {
                display: flex;
                align-items: center;

                img {
                  margin-right: 2px;
                  width: 14px;
                  height: 14px;
                }
              }
            }
          }
          .wechat {
            position: relative;

            .wechatContent {
              padding: 0px 12px;
              margin-left: 10px;
              width: 202px;
              height: 45px;
              background: #ffffff;
              border-radius: 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;

              .loginLeft {
                font-size: 14px;
                color: rgba(0, 0, 0, 0.9);
                display: flex;
                align-items: center;

                img {
                  margin-right: 8px;
                  width: 22px;
                  height: 22px;
                }
              }

              .loginRight {
                width: 14px;
                height: 14px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }

            .cell {
              border: 1rpx solid red;
              width: 504rpx;
              height: 100rpx;
              position: absolute;
              top: 0;
              z-index: 9999;
            }
          }

          .replayImg {
            margin-left: 16rpx;
          }

          .chatMessage {
            margin-right: 10px;
            display: inline-block;
            margin-top: 5px;
            background: #fff;
            padding: 10px 16px;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            border-radius: 6px;
          }
          .replayImg {
            margin-right: 10px;
            width: 160px;
          }
        }
      }
      .positionSender {
        flex-direction: row-reverse;
      }
    }
    .senderBottom {
      margin: 0 auto;
      padding-top: 10px;

      border-radius: 6px 6px 6px 6px;
      width: 99%;
      min-height: 200px;
      background: #fff;
      .xian {
        margin: 0 auto;
        width: 955px;
        height: 1px;
        background: #dcdfe6;
        border-radius: 0px 0px 0px 0px;
      }
      .senderText {
        padding-left: 20px;
        padding-right: 20px;
        height: 60px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        color: #909399;
        img {
          width: 21px;
          height: 17px;
        }
        .Left {
          display: flex;
          align-items: center;
        }
        .senderBtn {
          margin-left: 10px;
          text-align: center;
          width: 56px;
          height: 30px;
          color: #fff;
          line-height: 30px;
          background: #1f86fe;
          border-radius: 4px 4px 4px 4px;
        }
        .fileStyle {
          margin-right: 5px;
          border-radius: 1px;
          padding: 7px 0px;
          color: #909399;
          background: #fff;
        }
      }
    }
  }
}
</style>
